import { Col, Form, Row } from "react-bootstrap";

interface IEpaField {
  label?: string;
  value?: string;
  content?: JSX.Element;
}

const EpaField2Rows = ({ label, value, content }: IEpaField) => (
  <div style={{ marginBottom: "10px" }}>
    <Row>
      <Col className="col-md-12">
        <Form.Label style={{ marginBottom: "0.2rem" }}>{label}</Form.Label>
      </Col>
    </Row>
    <Row>
      <Col className="col-md-12">{content ? content : value}</Col>
    </Row>
  </div>
);

export default EpaField2Rows;
